import locales from './../config/locales'

export default function localize(str) {
    return str.split('.').reduce((o,i)=>o[i], locales);
}



// WEBPACK FOOTER //
// ./app/localize.js